"use client";

import type { ComponentProps } from "react";
import { Input } from "@leabankab/component-library";
import { FormField } from "@leabankab/component-library/react-hook-form";

export type InputFieldProps = Omit<
	ComponentProps<typeof Input>,
	"name" | "value" | "defaultValue" | "onValueChange" | "error"
> & { name: string };

/** The library `Input`, bound to the surrounding react-hook-form form. */
export const InputField = ({ name, ...props }: InputFieldProps) => (
	<FormField
		name={name}
		render={({ field }) => (
			<Input {...props} {...field} value={field.value ?? ""} />
		)}
	/>
);
